import React from 'react';
import * as Types from 'pages/Pages/typings';
import _get from 'lodash/get';

import Typography from '@material-ui/core/Typography';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Divider from '@material-ui/core/Divider';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Radio from '@material-ui/core/Radio';

import makeStyles from '@material-ui/core/styles/makeStyles';

interface Props {
  isIndependentPage: boolean;
  values: Types.EntitySettingsFormValues;
  onChange: (field: string, value: any) => void;
}

function PageEditors({ isIndependentPage, values, onChange }: Props) {
  const classes = useStyles();

  const handleEditorChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange('settings.implicitEditorRule', e.target.value);
  };

  return (
    <div className={classes.root}>
      <Card classes={{ root: classes.cardRoot }}>
        <CardContent>
          <div className={classes.marginBottom3}>
            <Typography variant="h5">Page Editors</Typography>
            <Divider className={classes.divider} />
            <Typography variant="h6">Who can edit this page type?</Typography>
            <Typography className={classes.marginBottom1} variant="subtitle2">
              {isIndependentPage
                ? 'Sift administrators and assigned editors will have access to edit pages.'
                : 'Pages will be editable by administrators and editors that are explicitly assigned to an individual page by an existing editor. In addition, you may grant automatic edit access to certain page members'}
            </Typography>
            {!isIndependentPage && (
              <RadioGroup
                aria-label="page editors"
                name="page-editors"
                value={_get(values, ['settings', 'implicitEditorRule'])}
                onChange={handleEditorChange}
              >
                <FormControlLabel
                  value="admins"
                  control={<Radio />}
                  label={
                    <>
                      <Typography>No additional access</Typography>
                      <Typography variant="subtitle2">
                        Pages will only be editable by administrators and assigned editors.
                      </Typography>
                    </>
                  }
                />
                <FormControlLabel
                  value="leaders"
                  control={<Radio />}
                  label={
                    <>
                      <Typography>Team Leaders</Typography>
                      <Typography variant="subtitle2">
                        Pages will additionally be editable by all members who have any direct
                        reports.
                      </Typography>
                    </>
                  }
                />
                <FormControlLabel
                  value="members"
                  control={<Radio />}
                  label={
                    <>
                      <Typography>All members</Typography>
                      <Typography variant="subtitle2">
                        Pages will additionally be editable by all page members.
                      </Typography>
                    </>
                  }
                />
              </RadioGroup>
            )}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}

const useStyles = makeStyles((theme: any) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
  },
  cardRoot: {
    width: '100%',
  },
  marginBottom3: {
    marginBottom: theme.spacing(3),
  },
  divider: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  marginBottom1: {
    marginBottom: theme.spacing(),
  },
}));

export default PageEditors;
